import { LabelGenerator } from '../../types';

export const isRateReducingSoon: LabelGenerator = (product) => {
  const upcomingRates = product.interest_rates.upcoming_rates[0];
  if (!upcomingRates) {
    return false;
  }
  const rate = parseFloat(product.interest_rates.interest_rate_effective);
  const nextRate = parseFloat(upcomingRates.interest_rate_effective);
  if (isNaN(rate) || isNaN(nextRate)) {
    return false;
  }
  return nextRate < rate && 'RateReducingSoon';
};
